import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PlusIcon from '../../icons/plusicon';
import service from '../../services';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ActCreators } from '../../redux/bindActionCretor';
import SimpleReactValidator from 'simple-react-validator';
import alertify from 'alertifyjs';
import commonImage from '../../commonImage';
import AppRoutePicker from './AppRoutePicker';
import UploadForm from '../UploadForm';
import DeletefileIcon from '../../icons/DeletefileIcon';
import Loader from '../loader';
import PopUpCustomAll from '../fpg/create/popUpCustomAll';

let sub;

const CTA_TYPE = { APP_PAGE: 'appPage', EXTERNAL_URL: 'externalUrl', NONE: 'none' };
const MAX_PARAMS = 5;
const MAX_MESSAGE_LENGTH = 140;
const MAX_IMAGE_SIZE_MB = 2;

const mapStateToProps = (state) => ({
    notificationId: state.notificationId,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActCreators, dispatch);
};

class MobileCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: '',
            message: '',
            messageLength: 0,
            imageFile: null,
            imagePreview: null,
            imageUrl: '',
            ctaType: CTA_TYPE.APP_PAGE,
            ctaLink: '',
            params: [],
            notificationId: this.props.notificationId,
            getLastUpdated: null,
            imageUploading: false,
            loaderFlag: false,
            showConfirmPopup: false,
        };
        this.apiserve = new service();
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        this.pendingPayload = null;
    }

    componentWillUnmount = () => {
        if (sub) sub.unsubscribe();
    };

    componentDidMount = () => {
        this.apiserve.sendevent('admin|lastNotyUpdate', {});
        if (this.state.notificationId) {
            this.apiserve.sendevent('admin|viewNoty', { notificationId: this.state.notificationId });
        }
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case 'notification|create':
                    if (response.error) {
                        this.setState({ loaderFlag: false, imageUploading: false });
                        alertify.error(response.data?.error || 'Failed to create notification.');
                    } else {
                        this.apiserve.sendevent('notification|send', this.pendingPayload);
                    }
                    break;
                case 'notification|send':
                    this.setState({ loaderFlag: false, imageUploading: false });
                    if (!response.error) {
                        this.props.history.push('/notifications');
                    } else {
                        alertify.error(response.data?.error || 'Failed to send notification.');
                    }
                    break;
                case 'admin|viewNoty':
                    if (!response.error && response.data?.docs?.[0]) {
                        const doc = response.data.docs[0];
                        const actionValue = doc.actionValue || {};
                        const reservedKeys = ['path', 'type', 'id'];
                        const restoredParams = Object.entries(actionValue)
                            .filter(([k]) => !reservedKeys.includes(k))
                            .map(([key, value]) => ({ key, value: String(value) }))
                            .slice(0, MAX_PARAMS);
                        const ctaType = actionValue.type === 'url'
                            ? CTA_TYPE.EXTERNAL_URL
                            : actionValue.type === 'page'
                                ? CTA_TYPE.APP_PAGE
                                : CTA_TYPE.NONE;
                        this.setState({
                            title: doc.title || '',
                            message: doc.message || '',
                            messageLength: (doc.message || '').length,
                            imageUrl: doc.image || '',
                            imagePreview: doc.image || null,
                            ctaType,
                            ctaLink: actionValue.path || '',
                            params: restoredParams,
                        });
                    }
                    break;
                case 'admin|lastNotyUpdate':
                    this.setState({ getLastUpdated: response.data?.[0] || null });
                    break;
                default:
                    break;
            }
        });
    };

    handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleMessageChange = (e) => {
        const value = e.target.value;
        if (value.length <= MAX_MESSAGE_LENGTH) {
            this.setState({ message: value, messageLength: value.length });
        }
    };

    handleImageChange = (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            const fileSize = Math.round(file.size / 1024);
            if (fileSize >= MAX_IMAGE_SIZE_MB * 1024) {
                alertify.error(`Please upload a file smaller than ${MAX_IMAGE_SIZE_MB} MB`);
                return;
            }
            const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg'];
            if (!allowedTypes.includes(file.type)) {
                alertify.error('Please upload PNG, JPG or JPEG only');
                return;
            }
            this.setState({ imageFile: file, imagePreview: event.target.result });
        };
    };

    handleImageRemove = () => {
        this.setState({ imageFile: null, imagePreview: null, imageUrl: '' });
    };

    handleCtaTypeChange = (type) => {
        this.setState({ ctaType: type, ctaLink: '' });
    };

    handleCtaLinkChange = (value) => {
        this.setState({ ctaLink: value });
    };

    addParam = () => {
        const { params } = this.state;
        if (params.length >= MAX_PARAMS) return;
        this.setState({ params: [...params, { key: '', value: '' }] });
    };

    removeParam = (index) => {
        this.setState({ params: this.state.params.filter((_, i) => i !== index) });
    };

    handleParamChange = (index, field, value) => {
        const params = this.state.params.map((p, i) => (i === index ? { ...p, [field]: value } : p));
        this.setState({ params });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.validator.purgeFields();
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            this.forceUpdate();
            return;
        }
        this.setState({ showConfirmPopup: true });
    };

    confirmSend = async () => {
        this.setState({ showConfirmPopup: false, loaderFlag: true });

        let imageUrl = this.state.imageUrl;
        if (this.state.imageFile) {
            this.setState({ imageUploading: true });
            try {
                const ext = this.state.imageFile.name.split('.').pop();
                const fileName = `NOTIFICATION_IMAGE_${Date.now()}.${ext}`;
                const s3Url = await commonImage(
                    this.state.imageFile,
                    false,
                    { street: `assest/${process.env.REACT_APP_ENVIRONMENT}` },
                    this.state.imagePreview,
                    fileName
                );
                if (!s3Url) throw new Error('Upload failed');
                imageUrl = s3Url;
            } catch (err) {
                this.setState({ loaderFlag: false, imageUploading: false });
                alertify.error('Image upload failed. Please try again.');
                return;
            }
        }

        const { title, message, ctaType, ctaLink, params } = this.state;

        const extraParams = params
            .filter((p) => p.key.trim())
            .reduce((acc, p) => ({ ...acc, [p.key.trim()]: p.value }), {});

        const actionValue = ctaType !== CTA_TYPE.NONE
            ? {
                path: ctaLink,
                type: ctaType === CTA_TYPE.EXTERNAL_URL ? 'url' : 'page',
                ...extraParams,
            }
            : null;

        const fullImageUrl = imageUrl
            ? this.apiserve.imageUrl + imageUrl
            : '';

        this.pendingPayload = {
            isAllUsers: true,
            title,
            message,
            ...(fullImageUrl ? { image: fullImageUrl } : {}),
            ...(actionValue ? { actionValue } : {}),
        };

        this.apiserve.sendevent('notification|create', this.pendingPayload);
    };

    handleReset = () => {
        this.setState({
            title: '',
            message: '',
            messageLength: 0,
            imageFile: null,
            imagePreview: null,
            imageUrl: '',
            ctaType: CTA_TYPE.APP_PAGE,
            ctaLink: '',
            params: [],
        });
        this.validator.hideMessages();
    };

    clearAllForm = () => {
        this.handleReset();
        this.props.NotificationEditData('');
    };

    render() {
        const {
            title, message, messageLength, imagePreview,
            ctaType, ctaLink, params, getLastUpdated,
            loaderFlag, imageUploading,
        } = this.state;

        const updateAt = new Date(getLastUpdated?.updatedAt);
        const isExternal = ctaType === CTA_TYPE.EXTERNAL_URL;
        const isNone = ctaType === CTA_TYPE.NONE;

        return (
            <React.Fragment>
                <div className="right_side_wrapper relative">
                    <div className="bradcrumb disp_flex d_flex_justify_spacebt d_flex_align_center">
                        <ul className="disp_flex">
                            <li>Send Mobile Notification</li>
                        </ul>
                        <Link className="add_page" onClick={() => this.clearAllForm()}><PlusIcon /></Link>
                    </div>
                    <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                        <Link className="back_link" to="/notifications">
                            <svg width="5" height="10" viewBox="0 0 5 10" fill="none">
                                <path d="M5 0L0 5L5 10V0Z" fill="black" />
                            </svg> Back To List
                        </Link>
                        {getLastUpdated?.updatedAt && (
                            <p className="update_date">
                                Last Update: {moment(updateAt).format('h:mm A')} — {moment(updateAt).format('MM/DD/YYYY')}
                            </p>
                        )}
                    </div>

                    <div className="sd_welcome_msg_page">
                        <div className="sd_app_config_wrapper">
                            <div className="sd_welcome_form_card">
                                <form onSubmit={this.handleSubmit}>

                                    {/* Title */}
                                    <div className="sd_welcome_field_row">
                                        <label className="sd_welcome_label">Title</label>
                                        <div className="sd_welcome_input_wrap">
                                            <input
                                                type="text"
                                                className="sd_welcome_input"
                                                name="title"
                                                value={title}
                                                onChange={this.handleInputChange}
                                                placeholder="Notification title"
                                                autoComplete="off"
                                            />
                                            <span className="sd_welcome_error">
                                                {this.validator.message('title', title, 'required')}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Message */}
                                    <div className="sd_welcome_field_row">
                                        <label className="sd_welcome_label">Message</label>
                                        <div className="sd_welcome_input_wrap">
                                            <textarea
                                                className="sd_welcome_input sd_welcome_textarea"
                                                name="message"
                                                value={message}
                                                onChange={this.handleMessageChange}
                                                placeholder="Notification message"
                                                rows={4}
                                            />
                                            <span className={`sd_noty_char_count${messageLength >= MAX_MESSAGE_LENGTH ? ' sd_noty_char_count_max' : ''}`}>
                                                {messageLength}/{MAX_MESSAGE_LENGTH}
                                            </span>
                                            <span className="sd_welcome_error">
                                                {this.validator.message('message', message, 'required')}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Image */}
                                    <div className="sd_welcome_field_row">
                                        <label className="sd_welcome_label">Image</label>
                                        <div className="sd_welcome_input_wrap">
                                            <div className="sd_noty_img_col">
                                                <div className="sd_popup_img_box loader-main">
                                                    <img
                                                        src={imagePreview || '/images/image-placeholder.png'}
                                                        onError={(e) => { e.target.src = '/images/image-placeholder.png'; }}
                                                        alt="Notification"
                                                    />
                                                    <UploadForm
                                                        item={{ _id: 'noty-img' }}
                                                        handleImage={this.handleImageChange}
                                                        accept=".png,.jpg,.jpeg"
                                                    />
                                                    {imagePreview && (
                                                        <span className="remove_file pointer" onClick={this.handleImageRemove}>
                                                            <DeletefileIcon />
                                                        </span>
                                                    )}
                                                </div>
                                                <span className="error_note">Max Size {MAX_IMAGE_SIZE_MB}MB · PNG, JPG or JPEG</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* CTA Type */}
                                    <div className="sd_welcome_field_row">
                                        <label className="sd_welcome_label p_0">CTA Type</label>
                                        <div className="sd_welcome_input_wrap">
                                            <div className="sd_app_config_radio_group">
                                                <label className="sd_radio_label">
                                                    <input
                                                        type="radio"
                                                        name="ctaType"
                                                        checked={ctaType === CTA_TYPE.APP_PAGE}
                                                        onChange={() => this.handleCtaTypeChange(CTA_TYPE.APP_PAGE)}
                                                    />
                                                    <span className="sd_radio_dot" />
                                                    App Page
                                                </label>
                                                <label className="sd_radio_label">
                                                    <input
                                                        type="radio"
                                                        name="ctaType"
                                                        checked={isExternal}
                                                        onChange={() => this.handleCtaTypeChange(CTA_TYPE.EXTERNAL_URL)}
                                                    />
                                                    <span className="sd_radio_dot" />
                                                    External URL
                                                </label>
                                                <label className="sd_radio_label">
                                                    <input
                                                        type="radio"
                                                        name="ctaType"
                                                        checked={isNone}
                                                        onChange={() => this.handleCtaTypeChange(CTA_TYPE.NONE)}
                                                    />
                                                    <span className="sd_radio_dot" />
                                                    None
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    {/* CTA Link — hidden when None */}
                                    {!isNone && (
                                        <div className="sd_welcome_field_row">
                                            <label className="sd_welcome_label">CTA Link</label>
                                            <div className="sd_welcome_input_wrap">
                                                {isExternal ? (
                                                    <input
                                                        type="text"
                                                        className="sd_welcome_input"
                                                        value={ctaLink}
                                                        onChange={(e) => this.handleCtaLinkChange(e.target.value)}
                                                        placeholder="https://..."
                                                        autoComplete="off"
                                                    />
                                                ) : (
                                                    <AppRoutePicker
                                                        value={ctaLink}
                                                        onChange={this.handleCtaLinkChange}
                                                        inputClass="sd_welcome_input"
                                                    />
                                                )}
                                                <span className="sd_welcome_error">
                                                    {this.validator.message('CTA Link', ctaLink, 'required')}
                                                </span>
                                            </div>
                                        </div>
                                    )}

                                    {/* Params — App Page only */}
                                    {ctaType === CTA_TYPE.APP_PAGE && <div className="sd_welcome_field_row">
                                        <label className="sd_welcome_label">Params</label>
                                        <div className="sd_welcome_input_wrap">
                                            {params.map((param, i) => (
                                                <div key={i} className="sd_noty_param_item">
                                                    <input
                                                        type="text"
                                                        className="sd_welcome_input sd_noty_param_input"
                                                        placeholder="Key"
                                                        value={param.key}
                                                        onChange={(e) => this.handleParamChange(i, 'key', e.target.value)}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="sd_welcome_input sd_noty_param_input"
                                                        placeholder="Value"
                                                        value={param.value}
                                                        onChange={(e) => this.handleParamChange(i, 'value', e.target.value)}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="sd_noty_param_remove"
                                                        onClick={() => this.removeParam(i)}
                                                        title="Remove param"
                                                    >
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                            <circle cx="10" cy="10" r="10" fill="#000" />
                                                            <rect x="5" y="9.25" width="10" height="1.5" rx="0.75" fill="#fff" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            ))}
                                            {params.length < MAX_PARAMS ? (
                                                <button
                                                    type="button"
                                                    className="sd_noty_add_param"
                                                    onClick={this.addParam}
                                                >
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="sd_noty_add_icon">
                                                        <circle cx="10" cy="10" r="10" fill="#000" />
                                                        <rect x="9.25" y="5" width="1.5" height="10" rx="0.75" fill="#fff" />
                                                        <rect x="5" y="9.25" width="10" height="1.5" rx="0.75" fill="#fff" />
                                                    </svg>
                                                </button>
                                            ) : (
                                                <span className="sd_welcome_hint">Maximum {MAX_PARAMS} params allowed.</span>
                                            )}
                                        </div>
                                    </div>}

                                    {/* Actions */}
                                    <div className="text_center field_row w_100 buttons_outer mb_0">
                                        <button className="uppercase" type="button" onClick={this.handleReset}>
                                            RESET
                                        </button>
                                        <button className="uppercase active" type="submit" disabled={imageUploading}>
                                            {imageUploading ? 'UPLOADING...' : 'SEND'}
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>

                    {/* Confirmation popup */}
                    {this.state.showConfirmPopup && (
                        <PopUpCustomAll
                            HeaderName="Send Notification"
                            insideDetails="Are you sure you want to send?"
                            insideData=""
                            popupState={() => this.setState({ showConfirmPopup: false })}
                            yesPopUp={this.confirmSend}
                            sendNotification={false}
                        />
                    )}

                    {loaderFlag && <Loader />}
                </div>
            </React.Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileCreate);
